import { ref, inject, reactive} from 'vue'
import { useStore } from 'vuex'

export const useElemental = () => {
    const $proxies = inject('$proxies')
    const store = useStore()
    const isSaved = ref(false)
    const $toast = inject('toast')
    const rowData = reactive({});
    const conforma = ref(false)
    const save = async (id) => {
        try {
            conforma.value = false
            const result = [];
            let ip = localStorage.getItem('adress');
            let nav = localStorage.getItem('nav');
            for (let i = 0; i < rowData.value.length; i++) {
                const element = rowData.value[i];
                /* VALIDAMOS EL PRIMER TRIMESTRES */
                if (!validarNumero(element.notas.a1 ? element.notas.a1 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                if (!validarNumero(element.notas.a2 ? element.notas.a2 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                if (!validarNumero(element.notas.a3 ? element.notas.a3 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                if (!validarNumero(element.notas.a4 ? element.notas.a4 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
    
                if (!validarNumero(element.notas.b1 ? element.notas.b1 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                if (!validarNumero(element.notas.b2 ? element.notas.b2 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                if (!validarNumero(element.notas.b3 ? element.notas.b3 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                if (!validarNumero(element.notas.b4 ? element.notas.b4 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
    
                if (!validarNumero(element.notas.pry1 ? element.notas.pry1 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });

                /* VALIDAMOS EL SEGUNDO TRIMESTRES */
                if (!validarNumero(element.notas.c1 ? element.notas.c1 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                if (!validarNumero(element.notas.c2 ? element.notas.c2 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                if (!validarNumero(element.notas.c3 ? element.notas.c3 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                if (!validarNumero(element.notas.c4 ? element.notas.c4 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
    
                if (!validarNumero(element.notas.d1 ? element.notas.d1 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                if (!validarNumero(element.notas.d2 ? element.notas.d2 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                if (!validarNumero(element.notas.d3 ? element.notas.d3 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                if (!validarNumero(element.notas.d4 ? element.notas.d4 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
    
                if (!validarNumero(element.notas.pry2 ? element.notas.pry2 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });

                 /* VALIDAMOS EL TERCER TRIMESTRES */
                 if (!validarNumero(element.notas.e1 ? element.notas.e1 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                 if (!validarNumero(element.notas.e2 ? element.notas.e2 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                 if (!validarNumero(element.notas.e3 ? element.notas.e3 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                 if (!validarNumero(element.notas.e4 ? element.notas.e4 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
     
                 if (!validarNumero(element.notas.f1 ? element.notas.f1 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                 if (!validarNumero(element.notas.f2 ? element.notas.f2 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                 if (!validarNumero(element.notas.f3 ? element.notas.f3 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                 if (!validarNumero(element.notas.f4 ? element.notas.f4 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
     
                 if (!validarNumero(element.notas.pry3 ? element.notas.pry3 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                
                const data = {
                    docente: element.docente,
                    fkdocente: element.fkdocente,
                    fkmateria: element.fkmateria,
                    idMatricula: element.idMatricula,
                    materia: element.materia,
                    cualitativo: [{}],
                    notas: {
                        //===================PRIMER TRIMESTRE =================================
                        a1: element.notas.a1 ? ifDecimal3(element.notas.a1.toString().replace(",", ".")) : '',
                        a2: element.notas.a2 ? ifDecimal3(element.notas.a2.toString().replace(",", ".")) : '',
                        a3: element.notas.a3 ? ifDecimal3(element.notas.a3.toString().replace(",", ".")) : '',
                        a4: element.notas.a4 ? ifDecimal3(element.notas.a4.toString().replace(",", ".")) : '',
    
                        b1: element.notas.b1 ? ifDecimal3(element.notas.b1.toString().replace(",", ".")) : '',
                        b2: element.notas.b2 ? ifDecimal3(element.notas.b2.toString().replace(",", ".")) : '',
                        b3: element.notas.b3 ? ifDecimal3(element.notas.b3.toString().replace(",", ".")) : '',
                        b4: element.notas.b4 ? ifDecimal3(element.notas.b4.toString().replace(",", ".")) : '',
    
                        pry1: element.notas.pry1 ? ifDecimal3(element.notas.pry1.toString().replace(",", ".")) : '',
    
                        //===================SEGUNDO TRIMESTRE =================================
                        c1: element.notas.c1 ? ifDecimal3(element.notas.c1.toString().replace(",", ".")) : '',
                        c2: element.notas.c2 ? ifDecimal3(element.notas.c2.toString().replace(",", ".")) : '',
                        c3: element.notas.c3 ? ifDecimal3(element.notas.c3.toString().replace(",", ".")) : '',
                        c4: element.notas.c4 ? ifDecimal3(element.notas.c4.toString().replace(",", ".")) : '',
    
                        d1: element.notas.d1 ? ifDecimal3(element.notas.d1.toString().replace(",", ".")) : '',
                        d2: element.notas.d2 ? ifDecimal3(element.notas.d2.toString().replace(",", ".")) : '',
                        d3: element.notas.d3 ? ifDecimal3(element.notas.d3.toString().replace(",", ".")) : '',
                        d4: element.notas.d4 ? ifDecimal3(element.notas.d4.toString().replace(",", ".")) : '',
    
                        pry2: element.notas.pry2 ? ifDecimal3(element.notas.pry2.toString().replace(",", ".")) : '',
    
                        //===================TERCER TRIMESTRE =================================
                        e1: element.notas.e1 ? ifDecimal3(element.notas.e1.toString().replace(",", ".")) : '',
                        e2: element.notas.e2 ? ifDecimal3(element.notas.e2.toString().replace(",", ".")) : '',
                        e3: element.notas.e3 ? ifDecimal3(element.notas.e3.toString().replace(",", ".")) : '',
                        e4: element.notas.e4 ? ifDecimal3(element.notas.e4.toString().replace(",", ".")) : '',
    
                        f1: element.notas.f1 ? ifDecimal3(element.notas.f1.toString().replace(",", ".")) : '',
                        f2: element.notas.f2 ? ifDecimal3(element.notas.f2.toString().replace(",", ".")) : '',
                        f3: element.notas.f3 ? ifDecimal3(element.notas.f3.toString().replace(",", ".")) : '',
                        f4: element.notas.f4 ? ifDecimal3(element.notas.f4.toString().replace(",", ".")) : '',
    
                        pry3: element.notas.pry3 ? ifDecimal3(element.notas.pry3.toString().replace(",", ".")) : '',
                    },
                    resultados: {
                        notaFinal: element.resultados.notaFinal ? element.resultados.notaFinal:'',
                    },
                    isConfirm: element.isConfirm,
                    idComputo: element.idComputo,
                    idDistributivo: store.state.items.idDistributivo,
                    usuario: store.getters.user,
                    idCarga: store.state.items.idCargaHoraria,
                    ip : ip,
                    nav : nav
                }
                result.push(data)
            }
            if (result.length == 0) return
            isSaved.value = true;
            await $proxies._notasProxi.saveNotasEle(id, result)
            isSaved.value = false;
            $toast.show(`Calificaciones enviadas con exito`, { position: "top-right" });
            conforma.value = true
        } catch (error) {
            isSaved.value = false;
            conforma.value = false
        }
    }
    const saveCuarto = async (id) => {
        try {
            conforma.value = false
            const result = [];
            let ip = localStorage.getItem('adress');
            let nav = localStorage.getItem('nav');
            for (let i = 0; i < rowData.value.length; i++) {
                const element = rowData.value[i];
                /* VALIDAMOS EL PRIMER TRIMESTRES */
                if (!validarNumero(element.notas.a1 ? element.notas.a1 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                if (!validarNumero(element.notas.a2 ? element.notas.a2 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                if (!validarNumero(element.notas.a3 ? element.notas.a3 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                if (!validarNumero(element.notas.a4 ? element.notas.a4 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
    
                if (!validarNumero(element.notas.b1 ? element.notas.b1 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                if (!validarNumero(element.notas.b2 ? element.notas.b2 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                if (!validarNumero(element.notas.b3 ? element.notas.b3 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                if (!validarNumero(element.notas.b4 ? element.notas.b4 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
    
                if (!validarNumero(element.notas.pry1 ? element.notas.pry1 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                if (!validarNumero(element.notas.exa1 ? element.notas.exa1 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });

                /* VALIDAMOS EL SEGUNDO TRIMESTRES */
                if (!validarNumero(element.notas.c1 ? element.notas.c1 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                if (!validarNumero(element.notas.c2 ? element.notas.c2 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                if (!validarNumero(element.notas.c3 ? element.notas.c3 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                if (!validarNumero(element.notas.c4 ? element.notas.c4 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
    
                if (!validarNumero(element.notas.d1 ? element.notas.d1 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                if (!validarNumero(element.notas.d2 ? element.notas.d2 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                if (!validarNumero(element.notas.d3 ? element.notas.d3 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                if (!validarNumero(element.notas.d4 ? element.notas.d4 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
    
                if (!validarNumero(element.notas.pry2 ? element.notas.pry2 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                if (!validarNumero(element.notas.exa2 ? element.notas.exa2 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });

                 /* VALIDAMOS EL TERCER TRIMESTRES */
                 if (!validarNumero(element.notas.e1 ? element.notas.e1 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                 if (!validarNumero(element.notas.e2 ? element.notas.e2 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                 if (!validarNumero(element.notas.e3 ? element.notas.e3 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                 if (!validarNumero(element.notas.e4 ? element.notas.e4 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
     
                 if (!validarNumero(element.notas.f1 ? element.notas.f1 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                 if (!validarNumero(element.notas.f2 ? element.notas.f2 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                 if (!validarNumero(element.notas.f3 ? element.notas.f3 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                 if (!validarNumero(element.notas.f4 ? element.notas.f4 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
     
                 if (!validarNumero(element.notas.pry3 ? element.notas.pry3 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                 if (!validarNumero(element.notas.exa3 ? element.notas.exa3 : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                
                 
                 if (!validarNumero(element.resultados.pytf ? element.resultados.pytf : '')) return $toast.error(`La calificación ingresada no es valida`, { position: "top-right" });
                 const data = {
                    docente: element.docente,
                    fkdocente: element.fkdocente,
                    fkmateria: element.fkmateria,
                    idMatricula: element.idMatricula,
                    materia: element.materia,
                    cualitativo: [{}],
                    notas: {
                        //===================PRIMER TRIMESTRE =================================
                        a1: element.notas.a1 ? ifDecimal3(element.notas.a1.toString().replace(",", ".")) : '',
                        a2: element.notas.a2 ? ifDecimal3(element.notas.a2.toString().replace(",", ".")) : '',
                        a3: element.notas.a3 ? ifDecimal3(element.notas.a3.toString().replace(",", ".")) : '',
                        a4: element.notas.a4 ? ifDecimal3(element.notas.a4.toString().replace(",", ".")) : '',
    
                        b1: element.notas.b1 ? ifDecimal3(element.notas.b1.toString().replace(",", ".")) : '',
                        b2: element.notas.b2 ? ifDecimal3(element.notas.b2.toString().replace(",", ".")) : '',
                        b3: element.notas.b3 ? ifDecimal3(element.notas.b3.toString().replace(",", ".")) : '',
                        b4: element.notas.b4 ? ifDecimal3(element.notas.b4.toString().replace(",", ".")) : '',
    
                        pry1: element.notas.pry1 ? ifDecimal3(element.notas.pry1.toString().replace(",", ".")) : '',
                        exa1: element.notas.exa1 ? ifDecimal3(element.notas.exa1.toString().replace(",", ".")) : '',
                        //===================SEGUNDO TRIMESTRE =================================
                        c1: element.notas.c1 ? ifDecimal3(element.notas.c1.toString().replace(",", ".")) : '',
                        c2: element.notas.c2 ? ifDecimal3(element.notas.c2.toString().replace(",", ".")) : '',
                        c3: element.notas.c3 ? ifDecimal3(element.notas.c3.toString().replace(",", ".")) : '',
                        c4: element.notas.c4 ? ifDecimal3(element.notas.c4.toString().replace(",", ".")) : '',
    
                        d1: element.notas.d1 ? ifDecimal3(element.notas.d1.toString().replace(",", ".")) : '',
                        d2: element.notas.d2 ? ifDecimal3(element.notas.d2.toString().replace(",", ".")) : '',
                        d3: element.notas.d3 ? ifDecimal3(element.notas.d3.toString().replace(",", ".")) : '',
                        d4: element.notas.d4 ? ifDecimal3(element.notas.d4.toString().replace(",", ".")) : '',
    
                        pry2: element.notas.pry2 ? ifDecimal3(element.notas.pry2.toString().replace(",", ".")) : '',
                        exa2: element.notas.exa2 ? ifDecimal3(element.notas.exa2.toString().replace(",", ".")) : '',
    
                        //===================TERCER TRIMESTRE =================================
                        e1: element.notas.e1 ? ifDecimal3(element.notas.e1.toString().replace(",", ".")) : '',
                        e2: element.notas.e2 ? ifDecimal3(element.notas.e2.toString().replace(",", ".")) : '',
                        e3: element.notas.e3 ? ifDecimal3(element.notas.e3.toString().replace(",", ".")) : '',
                        e4: element.notas.e4 ? ifDecimal3(element.notas.e4.toString().replace(",", ".")) : '',
    
                        f1: element.notas.f1 ? ifDecimal3(element.notas.f1.toString().replace(",", ".")) : '',
                        f2: element.notas.f2 ? ifDecimal3(element.notas.f2.toString().replace(",", ".")) : '',
                        f3: element.notas.f3 ? ifDecimal3(element.notas.f3.toString().replace(",", ".")) : '',
                        f4: element.notas.f4 ? ifDecimal3(element.notas.f4.toString().replace(",", ".")) : '',
    
                        pry3: element.notas.pry3 ? ifDecimal3(element.notas.pry3.toString().replace(",", ".")) : '',
                        exa3: element.notas.exa3 ? ifDecimal3(element.notas.exa3.toString().replace(",", ".")) : '',

                    },
                    resultados: {
                        notaFinal: element.resultados.notaFinal ? element.resultados.notaFinal:'',
                        pytf: element.resultados.pytf ? ifDecimal3(element.resultados.pytf.toString().replace(",", ".")) : '',
                    },
                    isConfirm: element.isConfirm,
                    idComputo: element.idComputo,
                    idDistributivo: store.state.items.idDistributivo,
                    usuario: store.getters.user,
                    idCarga: store.state.items.idCargaHoraria,
                    ip : ip,
                    nav : nav
                }
                result.push(data)
            }
            if (result.length == 0) return
            isSaved.value = true;
            await $proxies._notasProxi.saveNotasEleCuartos(id, result)
            isSaved.value = false;
            $toast.show(`Calificaciones enviadas con exito`, { position: "top-right" });
            conforma.value = true
        } catch (error) {
            isSaved.value = false;
            conforma.value = false
        }
    }
    return {
        isSaved, rowData, save, conforma, saveCuarto
    }
}

function validarNumero(num) {
    let numm = num.toString().replace(",", ".")
    if (numm >= 0 && numm <= 10) return true;
    else return false;
}
const ifDecimal3 = (num) => {
    try {
        if (num != '') {
            var partes = num.toString().split('.');
            var re = /^-?[0-9]+$/;
            if (re.test(num)) return num + ".00";
            else if (partes[1]?.length == 1)  return num + "0";
            else {
                if(num==0) return '0.00'
                if(num=='0.00') return '0.00'
                return ifDecimal(trunc(num, 2))
            }
        } else return '';
    } catch (error) {
        return num
    }
};
function ifDecimal (num) {
    if (num != '') {
        var partes = num.toString().split('.');
        var re = /^-?[0-9]+$/;
        if (re.test(num)) return num + ".00";
        else if (partes[1]?.length == 1)  return num + "0";
        else return num
    } else return '';
};
function trunc(x, posiciones = 0) {
    var s = x.toString()
    var decimalLength = s.indexOf('.') + 1
    var numStr = s.substr(0, decimalLength + posiciones)
    return Number(numStr)
}